<div class="container">
  <div class="header">
    <div class="title">
      <span [fiTranslation]="title"></span>
    </div>
  </div>

  @if (description) {
    <div class="description" [fiTranslation]="description"></div>
  }

  <div class="button-row">
    <button (click)="confirm()" class="{{buttonClass}}">
      <span class="btn-title" [fiTranslation]="buttonText"></span>
      @if (buttonIcon) {
        <span class="btn-icon">
          <img alt="icon" src="{{buttonIcon}}">
        </span>
      }
    </button>
  </div>

</div>

